import { AxiosResponse } from 'axios';

import api from 'utils/apiClient';
import {
  ICPRecommendation,
  ICreateCPRecommendation, IFormOfferRecommendation,
  ICreateRecommendation, IEditCPRecommendation, IEditRecommendation, IOfferRecommendation,
  IRecommendation,
  IServiceItem,
  IServiceParams,
} from 'types/recommendations.types';
import { HydraListResponse, LoadListDataParams, LoadListDataResponse } from 'hooks/useListData';
import {
  ANALYSIS_TYPES,
  COMPLEX_PROGRAM_TYPES,
  MEDICAL_SERVICES_TYPES,
} from '../constants/recommendations';

export const loadServices = ({
  pageSize,
  cityIds,
  typeIds = [],
  ...params
}: LoadListDataParams<IServiceParams>): Promise<AxiosResponse<LoadListDataResponse<IServiceItem>>> => {
  return api.get('/searchAnalysisForWeRecommend', {
    params: {
      ...params,
      cityIds: cityIds.join(","),
      typeIds: typeIds?.length
        ? typeIds.join(",")
        : [...ANALYSIS_TYPES, ...COMPLEX_PROGRAM_TYPES, ...MEDICAL_SERVICES_TYPES],
    }
  });
};

export const loadRecommendations = ({
  pageSize,
  page
}: LoadListDataParams): Promise<AxiosResponse<HydraListResponse<IRecommendation>>> => {
  return api.get('/we_recommends', { params: { page, itemsPerPage: pageSize } });
};

export const createRecommendation = (data: ICreateRecommendation): Promise<AxiosResponse<ICreateRecommendation>> => {
  return api.post('/we_recommends', data);
};

export const deleteRecommendation = (data: { id: number }): Promise<AxiosResponse> => {
  return api.delete(`/we_recommends/${data.id}`);
};

export const editRecommendation = ({
  id,
  values,
}: { id: number, values: IEditRecommendation }): Promise<AxiosResponse> => {
  return api.patch(`/we_recommends/${id}`, values);
};

export const loadCPRecommendations = ({
  pageSize,
  page
}: LoadListDataParams): Promise<AxiosResponse<HydraListResponse<ICPRecommendation>>> => {
  return api.get('/complex_programs_for_yous', { params: { page, itemsPerPage: pageSize } });
};

export const createCPRecommendation = (data: ICreateCPRecommendation): Promise<AxiosResponse<ICreateRecommendation>> => {
  return api.post('/complex_programs_for_yous', data);
};

export const deleteCPRecommendation = (data: { id: number }): Promise<AxiosResponse> => {
  return api.delete(`/complex_programs_for_yous/${data.id}`);
};

export const editCPRecommendation = ({
  id,
  values,
}: { id: number, values: IEditCPRecommendation }): Promise<AxiosResponse> => {
  return api.patch(`/complex_programs_for_yous/${id}`, values);
};

export const createOfferRecommendation = (data: IFormOfferRecommendation): Promise<AxiosResponse> => {
  return api.post('/promotions_and_offers', data);
};

export const loadOfferRecommendations = ({
  pageSize,
  page
}: LoadListDataParams): Promise<AxiosResponse<HydraListResponse<IOfferRecommendation>>> => {
  return api.get('/promotions_and_offers', { params: { page, itemsPerPage: pageSize } });
};

export const deleteOfferRecommendation = (data: { id: number }): Promise<AxiosResponse> => {
  return api.delete(`/promotions_and_offers/${data.id}`);
};

export const editOfferRecommendation = ({
  id,
  values,
}: { id: number, values: IFormOfferRecommendation }): Promise<AxiosResponse> => {
  return api.patch(`/promotions_and_offers/${id}`, values);
};

export const uploadIcon = ({ file }: { file: Blob }) => {
  return api.post(`/icons`, { icon: file }, {
    headers: {
      'Content-Type': 'multipart/form-data',
      Accept: 'application/json',
    },
  });
};

